import styled from 'styled-components'

import { Color } from 'root-constants'

type TTitleProps = {
  color: string
  lang: string
}
type TButtonProps = {
  backgroundColor: string
}

const SMALLER_FONT_SIZE_LOCALES = ['fr', 'de']

export const StyledAcceptRefund = {
  Root: styled.div`
    max-width: 375px;
    width: 100%;
    margin: 0 auto;
    padding: 0 16px;
    display: flex;
    flex-direction: column;
  `,
  ImageContainer: styled.div`
    max-width: 343px;
    width: 100%;
    aspect-ratio: 343/280;
  `,
  Title: styled.p<TTitleProps>`
    font-size: ${({ lang }) =>
      SMALLER_FONT_SIZE_LOCALES.includes(lang) ? '22px' : '24px'};
    font-weight: 700;
    line-height: 32px;
    color: ${Color.BLUE_DARK};
    margin-top: 24px;

    strong {
      color: ${({ color }) => color || `${Color.BLUE_DARK}`};
    }
  `,
  Subtitle: styled.p`
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    color: ${Color.BLACK};
    margin-top: 16px;
  `,
  Button: styled.button<TButtonProps>`
    max-width: 343px;
    width: 100%;
    height: 56px;
    font-size: 17px;
    font-weight: 700;
    line-height: 24px;
    color: #fff;
    cursor: pointer;
    border: none;
    border-radius: 30px;
    outline: none;
    padding: 10px 16px;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    text-align: center;
    background-color: ${({ backgroundColor }) =>
      backgroundColor || Color.FAMIO};
  `,
}
